/** Default link to redirect on clicking promo banner */
const defaultLink = 'https://promo.sber.ru/greenday?utm_source=sravni.ru&utm_medium=&utm_campaign=greenday_specialproject_person_banner1_nov2022';
/** Default date to which count down timer */
const defaultDateTo = new Date(2022, 10, 11);
/** Default active period of the promo banner */
const defaultActivePeriod = {
    from: new Date(2022, 10, 3),
    to: new Date(2022, 10, 13),
};

export { defaultActivePeriod, defaultDateTo, defaultLink };
//# sourceMappingURL=defaultParams.js.map
